export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/utils/reflow.js
// module id = 1490
// module chunks = 2